var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 25.5,
    r: 25.5,
    fill: "#F1F1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3333 24.375C17.9773 24.375 18.5 24.879 18.5 25.5C18.5 26.121 17.9773 26.625 17.3333 26.625C16.6893 26.625 16.1667 26.121 16.1667 25.5C16.1667 24.879 16.6893 24.375 17.3333 24.375ZM25.5 32.25C26.144 32.25 26.6667 32.754 26.6667 33.375C26.6667 33.996 26.144 34.5 25.5 34.5C24.856 34.5 24.3333 33.996 24.3333 33.375C24.3333 32.754 24.856 32.25 25.5 32.25ZM33.6667 24.375C34.3107 24.375 34.8333 24.879 34.8333 25.5C34.8333 26.121 34.3107 26.625 33.6667 26.625C33.0227 26.625 32.5 26.121 32.5 25.5C32.5 24.879 33.0227 24.375 33.6667 24.375ZM19.6667 30C20.3107 30 20.8333 30.504 20.8333 31.125C20.8333 31.746 20.3107 32.25 19.6667 32.25C19.0227 32.25 18.5 31.746 18.5 31.125C18.5 30.504 19.0227 30 19.6667 30ZM19.6667 18.75C20.3107 18.75 20.8333 19.254 20.8333 19.875C20.8333 20.496 20.3107 21 19.6667 21C19.0227 21 18.5 20.496 18.5 19.875C18.5 19.254 19.0227 18.75 19.6667 18.75ZM31.3333 18.75C31.9773 18.75 32.5 19.254 32.5 19.875C32.5 20.496 31.9773 21 31.3333 21C30.6893 21 30.1667 20.496 30.1667 19.875C30.1667 19.254 30.6893 18.75 31.3333 18.75ZM26.6667 25.0342L32.1582 30.3296L30.5085 31.9204L24.3333 25.9657V16.5H26.6667V25.0342ZM13.8333 25.5C13.8333 19.2968 19.067 14.25 25.5 14.25C31.933 14.25 37.1667 19.2968 37.1667 25.5C37.1667 31.7033 31.933 36.75 25.5 36.75C19.067 36.75 13.8333 31.7033 13.8333 25.5ZM11.5 25.5C11.5 32.9441 17.7802 39 25.5 39C33.2198 39 39.5 32.9441 39.5 25.5C39.5 18.0559 33.2198 12 25.5 12C17.7802 12 11.5 18.0559 11.5 25.5Z",
    fill: "#212129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.8a29c0b2af982205ec99ec20a7dbe25f.svg";
export { ForwardRef as ReactComponent };